import request from '@/utils/request'

export function selectCarving(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/setCarving/selectCarving?access=${data}`,
        method: 'post',
       // data,
    })
}

export function upDateCarving(data) {
    return request({
        url: `api/serviceCenter/setCarving/upDateCarving`,
        method: 'post',
        data,
    })
}
export function bathDeleteCarving(data) {
    return request({
        url: `api/serviceCenter/setCarving/bathDeleteCarving`,
        method: 'post',
        data,
    })
}

export function addCarving(data) {
    return request({
        url: `api/serviceCenter/setCarving/addCarving`,
        method: 'post',
        data,
    })
}
